import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "../Pages/home";
import Portfolio from "../Pages/portfolio";
import Services from "../Pages/services";
import Contact from "../Pages/contact";
import logo from "../assets/logo_an-1.png";

import Changing from "../Changing";

import { Translation } from "react-i18next";

export default class Header extends Component {
  state = {
    mobileMenu: false,
  };

  // Open / close full-screen menu (ONLY MOBILE)
  toggleMobileMenu = () => {
    this.setState({ mobileMenu: !this.state.mobileMenu });
  };

  closeMobileMenu = () => {
    this.setState({ mobileMenu: false });
  };

  render() {
    const { mobileMenu } = this.state;

    return (
      <>
        <Navbar
          fixed="top"
          collapseOnSelect
          expand="md"
          variant="dark"
          style={{
            backgroundColor: "#46669cee",
            padding: "0.3em",
          }}
        >
          <Container>
            <Navbar.Brand href="/home" id="brend">
              <img
                src={logo}
                alt="logo design"
                className="img-fluid img-logo"
                width="40"
                height="40"
              />
              <span
                style={{
                  paddingLeft: "1em",
                  color: "white",
                  fontSize: "1.1em",
                }}
              >
                AN Design
              </span>
            </Navbar.Brand>

            {/* BURGER (ONLY MOBILE) */}
            <div
              className="d-md-none"
              onClick={this.toggleMobileMenu}
              style={{
                width: "30px",
                height: "22px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                cursor: "pointer",
              }}
            >
              <span
                style={{
                  height: "4px",
                  background: "white",
                  borderRadius: "2px",
                  transition: "0.3s",
                  transform: mobileMenu
                    ? "rotate(45deg) translateY(9px)"
                    : "none",
                }}
              ></span>
              <span
                style={{
                  height: "4px",
                  background: "white",
                  borderRadius: "2px",
                  opacity: mobileMenu ? 0 : 1,
                  transition: "0.3s",
                }}
              ></span>
              <span
                style={{
                  height: "4px",
                  background: "white",
                  borderRadius: "2px",
                  transition: "0.3s",
                  transform: mobileMenu
                    ? "rotate(-45deg) translateY(-9px)"
                    : "none",
                }}
              ></span>
            </div>

            {/* MOBILE SLIDE MENU LEFT */}
            <div className={`mobile-menu ${mobileMenu ? "open" : ""}`}>
              <a
                href="/home"
                className={this.state.activeLink === "/home" ? "active" : ""}
                onClick={() => {
                  this.setState({ activeLink: "/home" });
                  this.closeMobileMenu();
                }}
              >
                Home
              </a>
              <a
                href="/portfolio"
                className={
                  this.state.activeLink === "/portfolio" ? "active" : ""
                }
                onClick={() => {
                  this.setState({ activeLink: "/portfolio" });
                  this.closeMobileMenu();
                }}
              >
                Portfolio
              </a>
              <a
                href="/services"
                className={
                  this.state.activeLink === "/services" ? "active" : ""
                }
                onClick={() => {
                  this.setState({ activeLink: "/services" });
                  this.closeMobileMenu();
                }}
              >
                Services
              </a>
              <a
                href="/contact"
                className={this.state.activeLink === "/contact" ? "active" : ""}
                onClick={() => {
                  this.setState({ activeLink: "/contact" });
                  this.closeMobileMenu();
                }}
              >
                Contact
              </a>

              {/* languages */}
              <div
                className="sl-nav"
                style={{
                  color: "white",
                }}
              >
                <Changing />
              </div>
            </div>

            {/* MENU (ONLY DESKTOP) */}
            <Navbar.Collapse
              id="responsive-navbar-nav"
              className="d-none d-md-block"
            >
              <Translation>
                {(t) => (
                  <Nav className="mr-auto navbar-underline">
                    <Nav.Link
                      href="/home"
                      className="navbar-link"
                      style={{ color: "white" }}
                    >
                      {t(["nav.nav"])}
                    </Nav.Link>
                    <Nav.Link
                      href="/portfolio"
                      className="navbar-link"
                      style={{ color: "white" }}
                    >
                      {t(["nav.nav-2"])}
                    </Nav.Link>
                    <Nav.Link
                      href="/services"
                      className="navbar-link"
                      style={{ color: "white" }}
                    >
                      {t(["nav.nav-3"])}
                    </Nav.Link>
                    <Nav.Link
                      href="/contact"
                      className="navbar-link"
                      style={{ color: "white" }}
                    >
                      {t(["nav.nav-4"])}
                    </Nav.Link>
                    <div className="navbar-link" style={{ marginLeft: "1em" }}>
                      <Changing />
                    </div>
                  </Nav>
                )}
              </Translation>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        {/* ROUTER */}
        <Router>
          <Routes>
            <Route path="/home" element={<Home />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Router>
      </>
    );
  }
}
